import { isProd } from 'shared/utils/isProd'

type FeatureFlagsMap = {
  USERFLOW: boolean
  USER_SURVEY: boolean
  MENU_COMPANY_SELECTOR: boolean
  TWO_FA_REMINDER: boolean
  REGISTER: boolean
  SHOW_REMEMBER_ME: boolean
  SEARCH: boolean
  FORCE_DETACHED_MODE: boolean
  SENTRY_ENABLED: boolean
  FULL_PAGE_ONBOARDING: (data: {
    organizationId: number
    isSffOrg: boolean
  }) => boolean
  APP_FOCUS_CHANGE_DEV_LOGGING_ENABLED: boolean
  APP_FOCUS_HEARTBEAT_DEV_LOGGING_ENABLED: boolean
}

export const FEATURE_FLAGS: FeatureFlagsMap = {
  USERFLOW: true,
  USER_SURVEY: !isProd(),
  MENU_COMPANY_SELECTOR: true,
  TWO_FA_REMINDER: true,
  REGISTER: true,
  SHOW_REMEMBER_ME: false,
  SEARCH: true,
  FORCE_DETACHED_MODE: isProd(),
  SENTRY_ENABLED: !isProd(),
  FULL_PAGE_ONBOARDING: ({ organizationId, isSffOrg }) =>
    ![7529, 13184].includes(organizationId) && isSffOrg,
  APP_FOCUS_CHANGE_DEV_LOGGING_ENABLED: !isProd(),
  APP_FOCUS_HEARTBEAT_DEV_LOGGING_ENABLED: false
} as const
